import { useBlocker, useNavigate, useParams } from 'react-router-dom';
import Button from '../../../../../component/ui/Button';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { createInvoice, updateInvoice } from '../../../../../services/invoices';
import Modal from '../../../../../component/modal/Modal';
import { getRoundedOff, getRoundedOffAmount } from '../../../components/TaxesCalculation';
import { hasPermission } from '../../../../../utils/controller';
import { useSelector } from 'react-redux';
import InputField from '../../../../../component/form/FormInput';
import { editInvoiceVerifyPassword } from '../../../../../services/settings/sales';
import usePaymentMethod from '../../../../purchasebills/hooks/usePaymentMethod';

const CreateInvoiceHeader = ({
	error,
	setError,
	tableError,
	setTableError,
	invoice,
	invoiceTable,
	totalAmount,
	isDraft,
	totalDiscountAmount,
	totalTaxesAmount,
	calculateAmount,
	saveInvoice,
	deleteInvoice,
	additionDiscountAndTax,
}) => {
	const navigate = useNavigate();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const suburl = localStorage.getItem('suburl');
	const { paymentMethodList } = usePaymentMethod();
	const param = useParams();
	const id = param?.id;
	const [loading, setLoading] = useState({
		isLoading: false,
		status: null,
		isSendEmail: false,
	});
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isInvoiceAutoSave, setIsInvoiceAutoSave] = useState(false);
	const [isSaveWIthEmail, setIisSaveWIthEmail] = useState(false);
	const [saveAsDraft, setSaveAsDraft] = useState(false);
	const [editInvoicePassword, setEditInvoicePassword] = useState('');
	const [errorPassword, setErrorPassword] = useState('');
	const [isAllowPasswordUpdateInvoice, setIsAllowPasswordUpdateInvoice] = useState(false);

	const checkValidation = (status) => {
		let newError = { ...error };
		let newTableError = [...tableError];
		if (!invoice.customer_id || invoice.customer_id === '' || invoice.customer_id === undefined) {
			newError.customer_id = 'Please select a valid customer from the list.';
		} else {
			delete newError.customer_id;
		}

		if (
			!invoice.invoice_number ||
			invoice.invoice_number === '' ||
			invoice.invoice_number === undefined
		) {
			newError.invoice_number = 'Please enter invoice number in the field';
		} else {
			delete newError.invoice_number;
		}
		if (status === 1) {
			if (
				!invoice.date ||
				invoice.date === '' ||
				invoice.date === undefined ||
				(invoice.date !== '' && newError.date)
			) {
				newError.date = newError.date ?? 'Please enter date in the field';
			} else {
				delete newError.date;
			}

			if (
				!invoice.payment_method ||
				invoice.payment_method === '' ||
				invoice.payment_method === undefined
			) {
				newError.payment_method = 'Please select a valid payment method from the list.';
			} else {
				delete newError.payment_method;
			}
		} else {
			delete newError.date;
			delete newError.payment_method;
		}

		// if (status === 1) {
		// 	if (invoiceTable.length > 0) {
		// 		let productIndex = Number(invoiceTable.length) - 1;
		// 		if (invoiceTable[productIndex].product_id === '') {
		// 			newTableError = [...newTableError, { index: productIndex, name: 'product_id' }];
		// 		} else {
		// 			delete newError.product_id;
		// 		}
		// 		if (
		// 			invoiceTable[productIndex].batch_no === '' ||
		// 			invoiceTable[productIndex].batch_no === null
		// 		) {
		// 			newTableError = [...newTableError, { index: productIndex, name: 'batch_no' }];
		// 		} else {
		// 			delete newError.batch_no;
		// 		}
		// 		if (
		// 			invoiceTable[productIndex].quantity === '' ||
		// 			invoiceTable[productIndex].quantity === null ||
		// 			Number(invoiceTable[productIndex].quantity) === 0
		// 		) {
		// 			newTableError = [...newTableError, { index: productIndex, name: 'quantity' }];
		// 		} else {
		// 			delete newError.quantity;
		// 		}
		// 	} else {
		// 		newTableError = [...newTableError, { index: 0, name: 'product_id' }];
		// 		newTableError = [...newTableError, { index: 0, name: 'batch_no' }];
		// 		newTableError = [...newTableError, { index: 0, name: 'quantity' }];
		// 	}
		// }
		// if (status === 1) {
		// 	invoiceTable.forEach((row, index) => {
		// 		const isRowEmpty = !row.product_id && !row.batch_no && !row.quantity;

		// 		// Skip completely empty rows
		// 		if (isRowEmpty) return;

		// 		if (!row.product_id) {
		// 			newTableError.push({ index, name: 'product_id' });
		// 		}

		// 		if (!row.batch_no) {
		// 			newTableError.push({ index, name: 'batch_no' });
		// 		}

		// 		if (!row.quantity || Number(row.quantity) === 0) {
		// 			newTableError.push({ index, name: 'quantity' });
		// 		}
		// 	});

		// 	// If no valid row exists
		// 	const validRowExists = invoiceTable.some(
		// 		(row) => row.product_id && row.batch_no && row.quantity && Number(row.quantity) > 0,
		// 	);

		// 	if (!validRowExists) {
		// 		newTableError.push({ index: 0, name: 'product_id' });
		// 	}
		// } else {
		// 	newTableError = [];
		// }
		if (status === 1) {
			// 🚨 First row validation
			const firstRow = invoiceTable[0];
			const isFirstRowEmpty =
				!firstRow?.product_id &&
				!firstRow?.batch_no &&
				(!firstRow?.quantity || Number(firstRow?.quantity) === 0);

			if (isFirstRowEmpty) {
				newTableError.push({ index: 0, name: 'product_id' });
				newTableError.push({ index: 0, name: 'batch_no' });
				newTableError.push({ index: 0, name: 'quantity' });
			} else {
				if (!firstRow.product_id) {
					newTableError.push({ index: 0, name: 'product_id' });
				}
				if (!firstRow?.batch_no) {
					newTableError.push({ index: 0, name: 'batch_no' });
				}
				if (!firstRow?.quantity || Number(firstRow?.quantity) === 0) {
					newTableError.push({ index: 0, name: 'quantity' });
					console.log(newTableError);
				}
			}

			// Validate remaining rows
			invoiceTable.slice(1).forEach((row, index) => {
				const rowIndex = index + 1;

				const isRowEmpty =
					!row.product_id && !row.batch_no && (!row.quantity || Number(row.quantity) === 0);
				// Ignore completely empty rows
				if (isRowEmpty) {
					newTableError = newTableError.filter((err) => err.index !== rowIndex);
				} else {
					if (!row.product_id) {
						newTableError.push({ index: rowIndex, name: 'product_id' });
					}

					if (!row.batch_no) {
						newTableError.push({ index: rowIndex, name: 'batch_no' });
					}

					if (!row.quantity || Number(row.quantity) === 0) {
						newTableError.push({ index: rowIndex, name: 'quantity' });
					}
				}
			});
		} else {
			// Draft save → ignore table errors
			newTableError = [];
		}
		if (Object.keys(newError).length > 0 || newTableError.length > 0) {
			setError(newError);
			setTableError(newTableError);
			return { status: true, isTableError: Object.keys(newError).length > 0 ? false : true };
		} else {
			return { status: false };
		}
	};

	const verifyPasswordForUpdateInvoice = async () => {
		try {
			var body = {
				invoice_password: editInvoicePassword,
			};
			const res = await editInvoiceVerifyPassword(body);
			if (res.success) {
				if (res?.data?.invoice_edit_token) {
					handleSubmitInvoice(saveAsDraft ? 0 : 1, isSaveWIthEmail, res?.data?.invoice_edit_token);
					setIsAllowPasswordUpdateInvoice(false);
				} else {
					toast.error('Password verification token is missing');
				}
			} else {
				toast.error(res.message);
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	const handleSubmitInvoice = async (status, isSendEmail = false, authToken = '') => {
		const isErrorShow = checkValidation(status);
		if (isErrorShow.status) {
			if (isErrorShow.isTableError) {
				toast.error('Error in Products List. Resolve the errors to continue.');
			} else if (status === 0) {
				toast.error('Please select a valid customer from the list.');
			} else {
				toast.error('Please fill all mandatory fields before saving');
			}
		} else {
			try {
				let invoice_id = null;
				setLoading((prev) => ({
					...prev,
					isLoading: true,
					status: status,
					isSendEmail: isSendEmail,
				}));

				const body = {
					customer_id: invoice.customer_id,
					doctor_id: invoice.doctor_id,
					account_id: invoice.account_id || null,
					invoice_number: invoice.invoice_number,
					date: invoice.date,
					sale_order_id: invoice.sale_order_id,
					remarks: invoice.remarks,
					payment_method_id: invoice.payment_method,
					due_date: invoice.due_date,
					status: status,
					discount: totalDiscountAmount(),
					adjustment: additionDiscountAndTax.adj ?? 0,
					taxes: totalTaxesAmount(),
					total_amount: getRoundedOffAmount(Number(totalAmount()).toFixed(2)),
					round_off: getRoundedOff(Number(totalAmount()).toFixed(2)),
					sub_total_amount: calculateAmount(),
					products:
						status === 0
							? invoiceTable.map((prod) => {
									const {
										quantity,
										mrp,
										expiry_date,
										batch_no,
										product_batch_id,
										amount,
										...rest
									} = prod;
									return {
										...rest,
										quantity: Number(quantity),
										mrp: Number(mrp),
										expiry: expiry_date,
										product_batch_id: Number(product_batch_id),
										amount: Number(amount),
									};
								})
							: invoiceTable
									.filter(
										(product) =>
											product.product_id !== '' &&
											product.product_id !== null &&
											product.quantity !== 0 &&
											product.quantity !== null &&
											product.quantity !== '' &&
											product.mrp !== 0 &&
											product.mrp !== '0.00' &&
											product.mrp !== null &&
											product.mrp !== '' &&
											product.amount !== 0 &&
											product.amount !== null &&
											product.amount !== '',
									)
									.map((prod) => {
										const {
											quantity,
											mrp,
											expiry_date,
											batch_no,
											product_batch_id,
											amount,
											...rest
										} = prod;
										return {
											...rest,
											quantity: Number(quantity),
											mrp: Number(mrp),
											expiry: expiry_date,
											product_batch_id: Number(product_batch_id),
											amount: Number(amount),
										};
									}),
				};

				if (id && !id.includes('id')) {
					if (navigator.onLine) {
						const res = await updateInvoice(id, body, authToken);
						if (res.success) {
							toast.success('Inovice updated Successfully');
							if (
								isSendEmail &&
								hasPermission('sales.invoices.communications_email', user?.role?.role_permissions)
							) {
								navigate(`/user/${suburl}/invoice-send-emails/${invoice_id}`);
							} else {
								navigate(`/user/${suburl}/invoices`);
							}
							deleteInvoice();
						} else {
							toast.error(res.message);
						}
					} else {
						saveInvoice(body);
						toast.success('Offline Invoice updated successfully.');
					}
				} else {
					if (navigator.onLine) {
						let res = await createInvoice(body);
						if (res.success) {
							invoice_id = res.data.invoice?.id;
							const modelStatus = !paymentMethodList.some(
								(item) =>
									item.key === invoice.payment_method &&
									(item.value === 'Credit' || item.value === 'Credit Note'),
							);
							toast.success('Invoice Created Successfully');
							if (isSendEmail) {
								setIsLocationBlocker(false);
								setIsInvoiceAutoSave(false);
								setTimeout(() => {
									navigate(`/user/${suburl}/invoice-send-emails/${invoice_id}`);
								}, 300);
							} else {
								setIsLocationBlocker(false);
								setIsInvoiceAutoSave(false);
								setTimeout(() => {
									navigate(`/user/${suburl}/invoices-details/${invoice_id}`, {
										state: { isOpen: status === 1 ? modelStatus : false },
									});
								}, 300);
							}
							deleteInvoice();
						} else {
							toast.error(res.message ?? 'something went wrong');
						}
					} else {
						saveInvoice(body);
						toast.success('Offline Invoice created successfully.');
					}
				}
			} catch (error) {
				toast.error(error.message ?? 'something went wrong');
			} finally {
				setLoading((prev) => ({
					...prev,
					isLoading: false,
					status: status,
					isSendEmail: isSendEmail,
				}));
			}
		}
	};

	useBlocker((tx) => {
		if (!id && isLocationBlocker) {
			setIsNextLocation(tx);
			setIsInvoiceAutoSave(true);
			return true;
		}
		return false;
	});

	return (
		<div className="product-pg-header add-product">
			<p>
				{id ? 'Update ' : 'Create New '}
				Invoice
			</p>
			<div className="add-product-button">
				<Button
					type="button"
					className="btn-primary mt-0 px-4"
					button="Save"
					loader={loading?.status === 1 && loading.isLoading && !loading.isSendEmail}
					disabled={
						(loading?.status === 1 && loading.isLoading && !loading.isSendEmail) ||
						(id
							? !hasPermission('sales.invoices.edit', user?.role?.role_permissions)
							: !hasPermission('sales.invoices.create', user?.role?.role_permissions))
					}
					onClick={() => {
						if (
							id &&
							!id.includes('id') &&
							user?.settings?.sales?.allow_editing_sales_invoice?.value
						) {
							setIsInvoiceAutoSave(false);
							setIsAllowPasswordUpdateInvoice(true);
							setIisSaveWIthEmail(false);
							setSaveAsDraft(false);
						} else {
							setIsInvoiceAutoSave(false);
							handleSubmitInvoice(1);
						}
					}}
				/>
				<Button
					type="button"
					className="btn-primary mt-0 px-4"
					button="Save and Send"
					loader={loading?.status === 1 && loading.isLoading && loading.isSendEmail}
					disabled={
						(loading?.status === 1 && loading.isLoading && loading.isSendEmail) ||
						!hasPermission('sales.invoices.communications_email', user?.role?.role_permissions)
					}
					onClick={() => {
						if (
							id &&
							!id.includes('id') &&
							!user?.settings?.sales?.allow_editing_sales_invoice?.value
						) {
							setIsInvoiceAutoSave(false);
							setIsAllowPasswordUpdateInvoice(true);
							setIisSaveWIthEmail(true);
							setSaveAsDraft(false);
						} else {
							setIsInvoiceAutoSave(false);
							handleSubmitInvoice(1, true);
						}
					}}
				/>
				{!id || (id && isDraft) ? (
					<Button
						type="button"
						className="btn-primary mt-0 px-4"
						button="Save as Draft"
						loader={loading?.status === 0 && loading.isLoading}
						disabled={
							(loading?.status === 0 && loading.isLoading) ||
							(id
								? !hasPermission('sales.invoices.edit', user?.role?.role_permissions)
								: !hasPermission('sales.invoices.create', user?.role?.role_permissions))
						}
						onClick={() => {
							if (
								id &&
								!id.includes('id') &&
								user?.settings?.sales?.allow_editing_sales_invoice?.value
							) {
								setIsInvoiceAutoSave(false);
								setIsAllowPasswordUpdateInvoice(true);
								setIisSaveWIthEmail(false);
								setSaveAsDraft(true);
							} else {
								setIsInvoiceAutoSave(false);
								handleSubmitInvoice(0);
							}
						}}
					/>
				) : (
					<></>
				)}
				<Button
					type="button"
					className="mt-0 btn-danger add-pro"
					button=""
					close
					onClick={() => {
						if (id && !id.includes('id')) {
							deleteInvoice();
						}
						navigate(`/user/${suburl}/invoices`);
					}}
				/>
			</div>
			{isInvoiceAutoSave && (
				<Modal
					className="deleteVendorsModal"
					title="Invoice Auto Save"
					isOpen={isInvoiceAutoSave}
					onClose={() => {
						setIsInvoiceAutoSave(false);
					}}
					cancelButton={() => {
						setIsInvoiceAutoSave(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						You have unsaved changes. Do you want to continue without saving?
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							button="Leave Without Saving"
							className="mt-0 px-4 btn-danger relative"
							onClick={() => {
								setIsLocationBlocker(false);
								setIsInvoiceAutoSave(false);
								deleteInvoice();
								setTimeout(() => {
									navigate(isNextLocation.nextLocation?.pathname);
								}, 300);
							}}
						/>
						<Button
							type="button"
							button="Save As Draft"
							disabled={!hasPermission('sales.invoices.create', user?.role?.role_permissions)}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsInvoiceAutoSave(false);
								handleSubmitInvoice(0);
							}}
						/>
						<Button
							type="button"
							button="Save and Continue"
							disabled={!hasPermission('sales.invoices.create', user?.role?.role_permissions)}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsInvoiceAutoSave(false);
								handleSubmitInvoice(1);
							}}
						/>
					</div>
				</Modal>
			)}
			{isAllowPasswordUpdateInvoice && (
				<Modal
					className="invoice-otp-modal"
					title={`Confirm Changes`}
					isOpen={isAllowPasswordUpdateInvoice}
					onClose={() => {
						setIsAllowPasswordUpdateInvoice(false);
					}}
					cancelButton={() => {
						setIsAllowPasswordUpdateInvoice(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						For security reasons, please confirm your passeord to save changes to this invoice.
					</div>
					<div className="col-6 my-2">
						<InputField
							type="password"
							value={editInvoicePassword}
							placeholder="Password"
							label="Password"
							onChange={(value) => {
								setEditInvoicePassword(value);
								if (value) {
									setErrorPassword('');
								} else {
									setErrorPassword('Please enter password for update invoice');
								}
							}}
							error={errorPassword}
							required
							autoComplete="edit-invoice-password"
							showPasswordIcon
						/>
					</div>

					<div className="fs-5 fw-light mt-5 mb-3">
						This helps protect sensitive invoice updates{' '}
					</div>

					<div className="d-flex align-items-center justify-content-end gap-4 mt-4">
						<Button
							type="button"
							button={'Cancel'}
							className="mt-0 px-5 btn-secondary relative"
							onClick={() => setIsAllowPasswordUpdateInvoice(false)}
						/>
						<Button
							type="button"
							button={'Confirm & Save'}
							className="mt-0 px-5 btn-primary relative"
							onClick={() => {
								if (editInvoicePassword) {
									verifyPasswordForUpdateInvoice();
								} else {
									setErrorPassword('Please enter password for update invoice');
								}
							}}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
};
export default CreateInvoiceHeader;
